import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from '../../reducers/user/user.reducer';
import { selectAuthToken } from "@store/selectors/auth/auth.selectors";
import { ROLE_GROUPS, RoleConstants } from '../../../constants/roles';

export const selectUserState = createFeatureSelector<fromUser.State>(
  fromUser.userFeatureKey
);

export const selectActiveUser = createSelector(
    selectUserState,
    (state: fromUser.State) => ({
        displayName: getDisplayName(state.displayName, state.email),
        email: state.email,
        b2cID: state.b2cID,
        roles: state.roles,
        orgId: state.orgId,
        loggedInUser: state.loggedInUser
    })
);

export const selectIsLoggedIn = createSelector(
    selectUserState,
    selectAuthToken,
    (state: fromUser.State, authToken: string) => !!state.b2cID && authToken != "" && state.orgId != 0
);

export const selectUserOrgId = createSelector(
    selectUserState,
    (state: fromUser.State) => state.orgId
);

export const selectLoggedInUserRoles = createSelector(
  selectUserState,
  (userState) => userState.roles || []
);

export const selectIsStandardUser = createSelector(
  selectLoggedInUserRoles,
  (roles) => roles.includes(RoleConstants.USER)
);

export const selectIsAdmin = createSelector(
  selectLoggedInUserRoles,
  (roles) => roles.includes(RoleConstants.ADMIN)
);

export const selectIsSuperUser = createSelector(
  selectLoggedInUserRoles,
  (roles) => ROLE_GROUPS.SUPER_USER.some((role: string) => roles.includes(role))
);

export const selectHasAdminRights = createSelector(
  selectLoggedInUserRoles,
  (roles) => ROLE_GROUPS.ADMIN_ROLES.some((role: string) => roles.includes(role))
);

export const selectIsAdminNotSuperUser = createSelector(
  selectIsSuperUser,
  selectHasAdminRights,
  (isSuperUser, hasAdmin) => hasAdmin && !isSuperUser
);

export const selectIsMatrixPPAAdmin = createSelector(
  selectLoggedInUserRoles,
  (roles) => roles.includes(RoleConstants.MATRIX_PPA_ADMIN)
);

export const selectIsSuperUserNotMatrixPPAAdmin = createSelector(
  selectLoggedInUserRoles,
  (roles) => roles.includes(RoleConstants.SUPER_USER) && !roles.includes(RoleConstants.MATRIX_PPA_ADMIN)
);

export const selectCanUploadMeetingNotes = createSelector(
  selectLoggedInUserRoles,
  (roles) => ROLE_GROUPS.SUPER_USER.some((role: string) => roles.includes(role))
);

export const selectCanManageNotifications = createSelector(
  selectLoggedInUserRoles,
  (roles) => ROLE_GROUPS.SUPER_USER.some((role: string) => roles.includes(role))
);

export const selectLoggedInUserId = createSelector(
  selectUserState,
  (state: fromUser.State) => state.loggedInUser?.id ?? null
);



 function getDisplayName(displayName: string, email: string ) {
      if (displayName != null && displayName != '') {
        return displayName;
      } else if (email != null && email != '') {
        return email;
      } else {
          return ""
      }


  }
